import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, setDoc, collection, getDocs } from 'firebase/firestore';
import UsuariosAdmin from './UsuariosAdmin';
import AbaSelos from './AbaSelos';
import UsuariosESelos from './UsuariosESelos';

import './AdminPanelPage.css';
import DatasPorCategoria from './DatasPorCategoria';
import LinksPorCategoria from './LinksPorCategoria';
import EstadoPorCategoria from './EstadoPorCategoria';
import CorrecaoPorCategoria from './CorrecaoPorCategoria';
import { corrigirSnapDropdown } from '../services/corrigirSnapDropdown';
import AdminTermometreiro from './AdminTermometreiro';
import AdminEspecialistasApostas from './AdminEspecialistasApostas';
import AdminAjudaPontuacao from './AdminAjudaPontuacao';
import AdminComentarios from './AdminComentarios';
import AdminRegrasComunidade from './AdminRegrasComunidade';
import AdminSugerirCandidatos from './AdminSugerirCandidatos';

const ADMIN_UID = 'CwveE0ysF6agpZiWmG4beKqokNB3';

const premiacoes = [
  { nome: 'Oscar', id: 'oscar' },
  { nome: 'Globo de Ouro', id: 'globodeouro' },
  { nome: 'Critics Choice', id: 'criticschoice' },
  { nome: 'The Actor Awards', id: 'sagawards' },
  { nome: 'BAFTA', id: 'bafta' },
  { nome: 'DGA', id: 'dga' },
  { nome: 'PGA', id: 'pga' },
];

const imagens = {
  oscar: {
    indicado: {
      aberto: 'https://i.imgur.com/5SUZ6wZ.png',
      fechado: 'https://i.imgur.com/x2EWbFI.png',
    },
    vencedor: {
      aberto: 'https://i.imgur.com/5SUZ6wZ.png',
      fechado: 'https://i.imgur.com/x2EWbFI.png',
    },
  },
  bafta: {
    indicado: {
      aberto: 'https://i.imgur.com/XBeG19f.png',
      fechado: 'https://i.imgur.com/vZ68Jkm.png',
    },
    vencedor: {
      aberto: 'https://i.imgur.com/XBeG19f.png',
      fechado: 'https://i.imgur.com/vZ68Jkm.png',
    },
  },
  sagawards: {
    indicado: {
      aberto: 'https://i.imgur.com/QC0vArh.png',
      fechado: 'https://i.imgur.com/ZA1zzI3.png',
    },
    vencedor: {
      aberto: 'https://i.imgur.com/QC0vArh.png',
      fechado: 'https://i.imgur.com/ZA1zzI3.png',
    },
  },
  globodeouro: {
    indicado: {
      aberto: 'https://i.imgur.com/uR5JRNI.png',
      fechado: 'https://i.imgur.com/VyadZRP.png',
    },
    vencedor: {
      aberto: 'https://i.imgur.com/uR5JRNI.png',
      fechado: 'https://i.imgur.com/VyadZRP.png',
    },
  },
  dga: {
    indicado: {
      aberto: 'https://i.imgur.com/txxZPPX.png',
      fechado: 'https://i.imgur.com/6GF5mGw.png',
    },
    vencedor: {
      aberto: 'https://i.imgur.com/txxZPPX.png',
      fechado: 'https://i.imgur.com/6GF5mGw.png',
    },
  },
  pga: {
    indicado: {
      aberto: 'https://i.imgur.com/sRVL7lJ.png',
      fechado: 'https://i.imgur.com/Nc6ehJD.png',
    },
    vencedor: {
      aberto: 'https://i.imgur.com/sRVL7lJ.png',
      fechado: 'https://i.imgur.com/Nc6ehJD.png',
    },
  },
  criticschoice: {
    indicado: {
      aberto: 'https://i.imgur.com/TQcwZ2F.png',
      fechado: 'https://i.imgur.com/pF17P14.png',
    },
    vencedor: {
      aberto: 'https://i.imgur.com/TQcwZ2F.png',
      fechado: 'https://i.imgur.com/pF17P14.png',
    },
  },
};

function AdminPanelPage() {
  const navigate = useNavigate();
  const [autorizado, setAutorizado] = useState(null);
  const [controle, setControle] = useState({});
  const [abaSelecionada, setAbaSelecionada] = useState('geral');
  const [modoSelecionado, setModoSelecionado] = useState('oscar');
  const [tipoSelecionado, setTipoSelecionado] = useState('indicados');
  const [categoriasPorModo, setCategoriasPorModo] = useState({});
  const [selosExistentes, setSelosExistentes] = useState([]);
  const [alertaAtivo, setAlertaAtivo] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState("");
  const [carregandoAlerta, setCarregandoAlerta] = useState(true);

  useEffect(() => {
  async function carregarAlerta() {
    try {
      const ref = doc(db, "configuracaoGeral", "alertaUrgente");
      const snap = await getDoc(ref);

      if (snap.exists()) {
        const dados = snap.data();
        setAlertaAtivo(dados.alertaAtivo);
        setMensagemAlerta(dados.mensagem);
      }
    } catch (erro) {
      console.error("Erro ao buscar alerta:", erro);
    } finally {
      setCarregandoAlerta(false);
    }
  }

  carregarAlerta();
}, []);

async function salvarAlerta() {
  try {
    const ref = doc(db, "configuracaoGeral", "alertaUrgente");
    await setDoc(ref, {
      alertaAtivo,
      mensagem: mensagemAlerta
    });
    alert("Alerta atualizado com sucesso!");
  } catch (erro) {
    console.error("Erro ao salvar alerta:", erro);
    alert("Erro ao salvar alerta.");
  }
}

  useEffect(() => {
  async function buscarSelos() {
    try {
      const snap = await getDocs(collection(db, "selos"));
      const lista = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setSelosExistentes(lista);
    } catch (erro) {
      console.error("❌ Erro ao buscar selos existentes:", erro);
    }
  }

  if (abaSelecionada === 'usuariosSelos') {
    buscarSelos();
  }
}, [abaSelecionada]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user?.uid === ADMIN_UID) {
        setAutorizado(true);
      } else {
        setAutorizado(false);
        navigate('/perfil');
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  useEffect(() => {
  async function fetchConfiguracoes() {
    try {
      const ref = doc(db, 'configuracaoVotacao2', 'geral');
      const snap = await getDoc(ref);

      if (snap.exists()) {
        const dados = snap.data();

        // Garante que todos os IDs existem, mesmo que incompletos
        const novoControle = {};
        for (const { id } of premiacoes) {
          novoControle[id] = dados[id] || {
            statusIndicado: 'fechado',
            statusVencedor: 'fechado',
            abreIndicado: '',
            fechaIndicado: '',
            imagemIndicado: '',
            imagemVencedor: ''
          };
        }

        setControle(novoControle);
        console.log("✅ Configurações carregadas do documento geral");
      } else {
        console.warn("⚠️ Documento 'geral' não encontrado em configuracaoVotacao2");
      }
    } catch (erro) {
      console.error("❌ Erro ao carregar configurações:", erro);
    }
  }

  if (autorizado) fetchConfiguracoes();
}, [autorizado]);

  useEffect(() => {
    async function carregarCategoriasSeNecessario() {
      const chave = `${modoSelecionado}-${tipoSelecionado}`;
      if (categoriasPorModo[chave]) return;

      const snap = await getDocs(collection(db, `modos/${chave}/categorias`));
      const lista = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setCategoriasPorModo(prev => ({ ...prev, [chave]: lista }));
    }

    if (['datas', 'links', 'estado', 'correcao'].includes(abaSelecionada)) {
    carregarCategoriasSeNecessario();
    }
  }, [modoSelecionado, tipoSelecionado, abaSelecionada, categoriasPorModo]);

  const handleAlterar = async (id, campo, valor) => {
    const novo = {
      ...controle[id],
      [campo]: valor
    };

    if (campo === 'statusIndicado' || campo === 'statusVencedor') {
      const tipo = campo.includes('Indicado') ? 'indicado' : 'vencedor';
      const imagemCampo = campo === 'statusIndicado' ? 'imagemIndicado' : 'imagemVencedor';
      novo[imagemCampo] = imagens[id]?.[tipo]?.[valor] || '';
    }

    setControle((prev) => ({
      ...prev,
      [id]: novo
    }));

    await setDoc(doc(db, 'configuracaoVotacao2', 'geral'), {
      [id]: novo
    }, { merge: true });
  };

  const categoriasAtuais = categoriasPorModo[`${modoSelecionado}-${tipoSelecionado}`] || [];

  function formatarData(data) {
  if (!data) return 'Em breve';
  try {
    const dataObj = new Date(data);
    const dia = String(dataObj.getDate()).padStart(2, '0');
    const mes = String(dataObj.getMonth() + 1).padStart(2, '0');
    const ano = dataObj.getFullYear();
    const horas = String(dataObj.getHours()).padStart(2, '0');
    const minutos = String(dataObj.getMinutes()).padStart(2, '0');

    return `${dia}/${mes}/${ano} às ${horas}h${minutos}`;
  } catch (e) {
    return data; // fallback se não conseguir formatar
  }
}

  if (autorizado === null) return <p>A verificar permissões...</p>;
  if (!autorizado) return null;

  return (
    <div className="admin-container">
      <h1>Painel de Administração</h1>

      <div className="admin-tabs">
        <button className={abaSelecionada === 'geral' ? 'active' : ''} onClick={() => setAbaSelecionada('geral')}>Controle Geral</button>
        <button className={abaSelecionada === 'datas' ? 'active' : ''} onClick={() => setAbaSelecionada('datas')}>Datas por Categoria</button>
        <button className={abaSelecionada === 'links' ? 'active' : ''} onClick={() => setAbaSelecionada('links')}>Links por Categoria</button>
        <button className={abaSelecionada === 'estado' ? 'active' : ''} onClick={() => setAbaSelecionada('estado')}>Estado por Categoria</button>
          <button className={abaSelecionada === 'correcao' ? 'active' : ''} onClick={() => setAbaSelecionada('correcao')}>Correção por Categoria</button>
          <button className={abaSelecionada === 'usuarios' ? 'active' : ''} onClick={() => setAbaSelecionada('usuarios')}>Usuários</button>
          <button className={abaSelecionada === 'selos' ? 'active' : ''} onClick={() => setAbaSelecionada('selos')}> Selos </button>
          <button className={abaSelecionada === 'usuariosSelos' ? 'active' : ''} onClick={() => setAbaSelecionada('usuariosSelos')}> Usuários e Selos </button>
          <button className={abaSelecionada === 'alerta' ? 'active' : ''} onClick={() => setAbaSelecionada('alerta')}>Alerta</button>
          <button className={abaSelecionada === 'termometreiro' ? 'active' : ''} onClick={() => setAbaSelecionada('termometreiro')}> Termometreiro </button>
          <button className={abaSelecionada === 'especialistasApostas' ? 'active' : ''} onClick={() => setAbaSelecionada('especialistasApostas')}>Especialistas Apostas</button>
          <button className={abaSelecionada === 'ajuda' ? 'active' : ''} onClick={() => setAbaSelecionada('ajuda')}> Ajuda / Pontuação </button>
          <button className={abaSelecionada === 'comentarios' ? 'active' : ''} onClick={() => setAbaSelecionada('comentarios')}>Comentários</button>
          <button className={abaSelecionada === 'regras' ? 'active' : ''} onClick={() => setAbaSelecionada('regras')}>Regras da Comunidade</button>
          <button className={abaSelecionada === 'sugeri' ? 'active' : ''} onClick={() => setAbaSelecionada('sugeri')}>Sugerir Candidatos</button>
      </div>

      {['datas', 'links', 'estado', 'correcao'].includes(abaSelecionada) && (
      <>
        <div className="admin-tabs">
          {premiacoes.map((p) => (
            <button
              key={p.id}
              className={modoSelecionado === p.id ? 'active' : ''}
              onClick={() => setModoSelecionado(p.id)}
            >
              {p.nome}
            </button>
          ))}
        </div>
        <div className="admin-tabs">
          {['indicados', 'vencedores'].map((tipo) => (
            <button
              key={tipo}
              className={tipoSelecionado === tipo ? 'active' : ''}
              onClick={() => setTipoSelecionado(tipo)}
            >
              {tipo.charAt(0).toUpperCase() + tipo.slice(1)}
            </button>
          ))}
        </div>
      </>
    )}

      {abaSelecionada === 'geral' && (
        <>
          {premiacoes.map(({ nome, id }) => (
            <div key={id} className="admin-premiacao-bloco">
              <h2>{nome}</h2>
              {['Indicado', 'Vencedor'].map((tipo) => {
                const campoStatus = `status${tipo}`;
                const campoAbre = `abre${tipo}`;
                const campoFecha = `fecha${tipo}`;
                const campoImagem = `imagem${tipo}`;
                const statusAtual = controle[id]?.[campoStatus];

                return (
                  <div key={tipo} className="admin-controle-linha">
                    <strong>Apostas de {tipo}:</strong>

                    <button onClick={() => handleAlterar(id, campoStatus, 'aberto')} disabled={statusAtual === 'aberto'}>ABRIR</button>
                    <button onClick={() => handleAlterar(id, campoStatus, 'fechado')} disabled={statusAtual === 'fechado'}>FECHAR</button>

                    <div className="datas">
                      <label>
                        Abre:
                        <input type="datetime-local" value={controle[id]?.[campoAbre] || ''} onChange={(e) => handleAlterar(id, campoAbre, e.target.value)} />
                      </label>
                      <label>
                        Fecha:
                        <input type="datetime-local" value={controle[id]?.[campoFecha] || ''} onChange={(e) => handleAlterar(id, campoFecha, e.target.value)} />
                      </label>
                    </div>

                    <div className="imagem-miniatura">
                      <p>Imagem atual:</p>
                      {controle[id]?.[campoImagem] ? (
                        <img src={controle[id][campoImagem]} alt={`Botão ${tipo}`} style={{ width: '120px', height: 'auto', borderRadius: '4px' }} />
                      ) : (
                        <p>[Sem imagem]</p>
                      )}
                    </div>

                    <p className="admin-info-text">
                      Estado atual: <strong>{statusAtual?.toUpperCase()}</strong> —
                      Abre dia: {formatarData(controle[id]?.[campoAbre])} |
                      Fecha dia: {formatarData(controle[id]?.[campoFecha])}
                    </p>
                  </div>
                );
              })}
            </div>
          ))}
        </>
      )}

      {abaSelecionada === 'datas' && (
        <DatasPorCategoria modo={`${modoSelecionado}-${tipoSelecionado}`} categorias={categoriasAtuais} />
      )}

      {abaSelecionada === 'links' && (
        <LinksPorCategoria modo={`${modoSelecionado}-${tipoSelecionado}`} categorias={categoriasAtuais} />
      )}

      {abaSelecionada === 'estado' && (
        <EstadoPorCategoria modo={`${modoSelecionado}-${tipoSelecionado}`} categorias={categoriasAtuais} />
      )}

        {abaSelecionada === 'correcao' && (
      <CorrecaoPorCategoria
        key={`${modoSelecionado}-${tipoSelecionado}`} // força recriação ao mudar aba
        modo={modoSelecionado}
        tipo={tipoSelecionado}
        categorias={categoriasAtuais}
      />
    )}

        {abaSelecionada === 'usuarios' && (
      <UsuariosAdmin />
    )}

    {abaSelecionada === 'selos' && (
      <AbaSelos />
    )}
    {abaSelecionada === 'usuariosSelos' && (
      <UsuariosESelos selosExistentes={selosExistentes} />
    )}

    {abaSelecionada === "alerta" && (
      <div className="painel-alerta">
        <h2>Alerta Urgente</h2>

        {carregandoAlerta ? (
          <p>A carregar alerta...</p>
        ) : (
          <>
            <label>Ativar alerta?</label>
            <select
              value={alertaAtivo ? "sim" : "nao"}
              onChange={(e) => setAlertaAtivo(e.target.value === "sim")}
            >
              <option value="sim">Sim</option>
              <option value="nao">Não</option>
            </select>

            <label>Mensagem do alerta:</label>
            <textarea
              value={mensagemAlerta}
              onChange={(e) => setMensagemAlerta(e.target.value)}
              rows={4}
              style={{ width: "100%", marginBottom: "10px" }}
            />

            <button className="btn" onClick={salvarAlerta}>
              Guardar alterações
            </button>
          </>
        )}
      </div>
    )}

         {abaSelecionada === 'termometreiro' && (
          <AdminTermometreiro />
        )}

        {abaSelecionada === 'especialistasApostas' && (  // <<< NOVO
        <AdminEspecialistasApostas />
      )}

      {abaSelecionada === 'ajuda' && (
        <AdminAjudaPontuacao />
      )}

      {abaSelecionada === 'comentarios' && (
      <AdminComentarios />
      )}

      {abaSelecionada === 'regras' && (
      <AdminRegrasComunidade />
      )}

      {abaSelecionada === 'sugeri' && (
        <AdminSugerirCandidatos />
      )}
      
    </div>
  );
}

export default AdminPanelPage;